// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "th.sortable[data-v-352853c6]{cursor:pointer;text-decoration:underline}", "",{"version":3,"sources":["webpack://./resources/js/screens/users/UsersList/components/UsersListHeader.vue"],"names":[],"mappings":"AACA,6BACE,cAAA,CACA,yBAAF","sourcesContent":["\nth.sortable{\n  cursor: pointer;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
